import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { useQuery } from "react-query"
import { useSelector } from "react-redux"
import useListingPagination from "../../common/hooks/UseListingPagination"
import ListingWrapper from "../../common/listing/ListingWrapper"
import { AdjusmentListingProps } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import { ImportAdjustment } from "../../state/inventory/adjustments/model/adjustment"
import { AdjustmentService } from "../../state/inventory/adjustments/service/adjustmentservice"
import { PRODUCT_TYPE } from "../../state/product/Types"
import { ProductSelector } from "../../state/product/selectors"
import { getHeadersData, getRowCellsData } from "../../utils/inventory/adjustmentListingHelper"
import { StockLocationTabs } from "./StockLocationTabs"

const AdjustmentListingPerStockLocation = (props: AdjusmentListingProps & IntlProps) => {
    const [activeTab, setActiveTab] = useState<string | null>(null)
    const [filters, setFilters] = useState({
        locationId: props.locationId,
        productId: props.product?.attributes.type == PRODUCT_TYPE.MATRIX_PARENT ? props.variantIds || [] : props.productId
    })
    const inventoryLocationQuantities = useSelector(ProductSelector.getInventoryLocationQuantities)

    useEffect(() => {
        refetch()
    }, [inventoryLocationQuantities])

    useEffect(() => {
        setFilters({
            locationId: filters.locationId,
            productId: props.product?.attributes.type == PRODUCT_TYPE.MATRIX_PARENT ? props.variantIds || [] : props.productId
        })
    },[props.variantIds])
   
    const {
        paginatedSearch,
        handleSorting,
        handlePageChange,
        updateTotalItemsCount,
        pagination,
    } = useListingPagination({
        keywords: "*",
        sortByField: "createdAt",
        sortAsc: false,
        pageSize: 25,
        activePage: 1,
        filters: filters,
    })

    const adjustmentQueryKey = ["stock-adjustment-listing-totals", activeTab, filters]
    const { error, isLoading, data: responseData, refetch } = useQuery([adjustmentQueryKey, paginatedSearch], () => {
        return AdjustmentService.findAdjustmentsBySearchPayload({ ...paginatedSearch, filters: filters })
    }, {
        enabled: !!activeTab,
        onSuccess: (data) => {
            updateTotalItemsCount(data.metadata.totalItemsCount)
        }
    })


    const metadata = responseData?.metadata
    const totalItemsCount = metadata?.totalItemsCount || 0

    const headers = {
        data: getHeadersData(paginatedSearch.sortByField, paginatedSearch.sortAsc, handleSorting, props.intl),
        classNames: [],
    }

    const rows = (adjustments:ImportAdjustment[]) => {
        return adjustments?.map(adjustment => {
            return {
                rowId: adjustment.id,
                data: getRowCellsData(adjustment),
            }
        })
    }

    const search = <></>


    return (
        <div className="pt-3 pb-2">
            <StockLocationTabs activeTab={activeTab}
                onTabChangeCallback={inventoryLocationId => {
                    setActiveTab(inventoryLocationId || "")
                    if (inventoryLocationId) {
                        handlePageChange(1)
                        setFilters({
                            productId: props.product?.attributes.type==PRODUCT_TYPE.MATRIX_PARENT?props.variantIds || []:props.productId,
                            locationId: inventoryLocationId
                        })
                    }
                }}
            />
            
            {activeTab && <ListingWrapper
                isLoading={isLoading}
                error={error as Error}
                search={search}
                showHeaders={true}
                standardListProps={{
                    className: "row pt-3",
                    headers: headers,
                    rows: rows(responseData?.data || [] ),
                    smallLine:true,
                    pageSize: paginatedSearch.pageSize,
                    totalItemsCount: totalItemsCount,
                    showSelectionSize: false,
                }}
                footer={
                    <div className="px-2"> 
                        {pagination()} 
                    </div>
                }
            />}
        </div>
    )
}

export default injectIntl(AdjustmentListingPerStockLocation)


// WEBPACK FOOTER //
// ./src/inventory/components/AdjustmentListingPerStockLocation.tsx